import { j as r } from "./index.es33.js";
import { Icon as o } from "./index.es7.js";
import s from "./index.es185.js";
var i = {
  info: {
    color: "var(--vds-gray-2)",
    borderColor: "var(--vds-gray-6)",
    icon: r.jsx(o, {
      className: s.typeIcon,
      icon: o.icons.system.s.stateIndicators.information,
      size: 16
    })
  },
  warning: {
    color: "var(--vds-orange-1)",
    borderColor: "var(--vds-orange-4)",
    icon: r.jsx(o, {
      className: s.typeIcon,
      icon: o.icons.system.s.stateIndicators.warning,
      size: 16
    })
  },
  error: {
    color: "var(--vds-red-1)",
    borderColor: "var(--vds-red-5)",
    icon: r.jsx(o, {
      className: s.typeIcon,
      icon: o.icons.system.s.stateIndicators.error,
      size: 16
    })
  }
};
export { i as INLINE_MESSAGE_TYPES_MAP };